export default "__VITE_ASSET__Bxi2c2CS__"